<template lang="pug">
  .component-create-entity-button
    .row
      .columns
        label Name
          input(type="text", v-model="localValue.name")
        label Description
          input(type="text", v-model="localValue.description")
        label Attachment views
          .input-group(v-if="typeof localValue.attachment_views !== 'string'", v-for="(attachments, index) in localValue.attachment_views")
            input.input-group-field(type='text', v-model="localValue.attachment_views[index]")
            .input-group-button
              button.button.warning(@click="localValue.attachment_views.splice(index, 1)") -
        button.button.small(@click="localValue.attachment_views.push([])") Add view
</template>
<script type="text/babel">

import BaseForm from "./BaseForm.vue";

export default {
  name: 'DocumentTypeForm',
  extends: BaseForm,
  components: {},
  data() {
    return {

    }
  },
  created() {
  },
  methods: {

  },
  props: ['value']
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// DocumentTypeForm.vue?2c9fb9cd